import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ViewUI from 'view-design'

import enLocale from './en.json'
import zhLocale from './zh.json'
import koLocale from './kor.json'
import iviewEn from 'view-design/dist/locale/en-US'
import iviewZh from 'view-design/dist/locale/zh-CN'
import iviewKo from 'view-design/dist/locale/ko-KR'
import { i18nChangeLanguage } from '@wangeditor/editor'
Vue.use(VueI18n)

// 自动检测浏览器语言
let defaultLang = navigator.language.toLowerCase()

// 从localStorage获取语言设置，如果没有则使用默认语言
const currentLang = localStorage.getItem('language') || defaultLang

i18nChangeLanguage(currentLang == 'zh-cn' ? 'zh-CN' : currentLang)

const i18n = new VueI18n({
  locale: currentLang,
  fallbackLocale: 'zh-cn',
  messages: {
    'en-us': {
      ...iviewEn,
      ...enLocale
    },
    'zh-cn': {
      ...iviewZh,
      ...zhLocale
    },
    'ko-kr': {
      ...iviewKo,
      ...koLocale
    }
  }
})

// 配置iview的国际化
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// 导出i18n实例和切换语言的方法
export default i18n

// 切换语言
export function setLanguage (lang) {
  localStorage.setItem('language', lang)
  return true
}



// WEBPACK FOOTER //
// ./src/lang/i18n.js